import momentTimeZone from 'moment-timezone';
import { uniq } from 'lodash';

const timeZonesSelect = () => {
  const timeZones = momentTimeZone.tz.names();

  const utcOffsets = timeZones.map(timeZoneName => {
    const timeZone = momentTimeZone.tz(timeZoneName);
    return timeZone.utcOffset();
  });

  const uniqOffsets = uniq(utcOffsets);

  const offsetObjects = uniqOffsets.map(offset => {
    const hours = Math.abs(Math.trunc(offset / 60));
    const minutes = Math.abs(offset % 60);
    if (hours === 0 && minutes === 0) {
      return { key: 0, text: 'UTC' };
    } else {
      const prefix = offset > 0 ? 'UTC +' : 'UTC -';
      const minutesTwoDigits = minutes === 0 ? '00' : minutes;
      return { key: offset, text: `${prefix}${hours}:${minutesTwoDigits}` };
    }
  });

  return offsetObjects.sort((a, b) => (a.key > b.key ? 1 : b.key > a.key ? -1 : 0));
};

export default timeZonesSelect;
